

<template>
  <AppHero
    kicker="Atendimento"
    title="Gerencie seus chamados"
    title-tag="h3"
    description="Abra novas solicitações, pesquise registros existentes e acompanhe as atualizações do atendimento da equipe de TI em um só lugar."
  >
    <template #aside>
      <div class="chamado-hero-search">
        <div class="search-box chamado-search-box">
          <input type="search" autocomplete="off" class="form-control chamado-search-input" v-model="query" @input="getDatabaseInput" :placeholder="'Pesquisar ...'" />
          <i class="ri-search-line search-icon"></i>
        </div>
      </div>
    </template>

    <div class="card tab-content text-muted">
      <div class="tab-pane active p-2" id="productnav-all" role="tabpanel">
        <div id="table-product-list-all" class=" px-4 table-card gridjs-border-none table-responsive chamado-table-shell">
          <div class="d-flex flex-column flex-md-row justify-content-between align-items-centerm mt-3 mb-3 gap-3">

            <div class="pagination-wrap hstack gap-2 justify-content-center justify-content-md-start">
              <label class="mt-1" for="perPage">Registros por página:</label>
              <BDropdown variant="link" toggle-class="btn btn-soft-primary btn-sm dropdown arrow-none"
                         menu-class="dropdown-menu-end"
                         :offset="{ alignmentAxis: -130, crossAxis: 0, mainAxis: 10 }">
                <template #button-content> {{perPage}} </template>
                <BDropdownItem @click="getDatabase({limit:10})">10</BDropdownItem>
                <BDropdownItem @click="getDatabase({limit:20})">20</BDropdownItem>
                <BDropdownItem @click="getDatabase({limit:50})">50</BDropdownItem>
                <BDropdownItem @click="getDatabase({limit:100})">100</BDropdownItem>
              </BDropdown>

              <button
                v-if="totalNaoLidos > 0"
                type="button"
                class="btn btn-sm chamado-filtro-novidade"
                :class="apenasNovidades ? 'btn-warning' : 'btn-soft-warning'"
                @click="apenasNovidades = !apenasNovidades"
              >
                <i class="ri-chat-3-fill me-1"></i>
                {{ totalNaoLidos }} com resposta nova
              </button>
            </div>

            <div v-if="loading" class="spinner-border text-primary" role="status"></div>

            <div v-else class="pagination-wrap hstack gap-2 justify-content-center justify-content-md-end">
              <BLink class="page-item pagination-prev" href="#" :disabled="page === 1" @click.prevent="page = 1">
                <span class="d-none d-lg-inline">Primeira página</span>
                <span class="d-lg-none">&lt;&lt;</span>
              </BLink>
              <BLink class="page-item pagination-prev" href="#" :disabled="page <= 1" @click.prevent="page--">
                <span class="d-none d-lg-inline">Anterior</span>
                <span class="d-lg-none">&lt;</span>
              </BLink>

              <ul class="pagination listjs-pagination mb-0 d-flex flex-wrap justify-content-center">
                <li v-for="(pageNumber, index) of pages" :key="index"
                    :class="{ active: typeof pageNumber === 'number' && pageNumber === page, disabled: pageNumber === '...', }">
                  <BLink class="page" href="#" @click.prevent="typeof pageNumber === 'number' ? page = pageNumber : null">
                    {{ pageNumber }}
                  </BLink>
                </li>
              </ul>

              <BLink class="page-item pagination-next" href="#" :disabled="page >= totalPages" @click.prevent="page++">
                <span class="d-none d-lg-inline">Seguinte</span>
                <span class="d-lg-none">&gt;</span>
              </BLink>
              <BLink class="page-item pagination-next" href="#" :disabled="page >= totalPages" @click.prevent="page = totalPages">
                <span class="d-none d-lg-inline">Última página</span>
                <span class="d-lg-none">&gt;&gt;</span>
              </BLink>
            </div>
          </div>
          <table class="table table-striped table-hover align-middle table-nowrap mb-0" id="customerTable">
            <thead class="table-light">
            <tr ref="campos" class="text-muted">
              <th class="d-lg-none" style="width: 50px;">Ver</th>

              <th style="cursor: pointer" key="id" class="sort" data-sort="id" @click="onSort('id')">Nº</th>
              <th style="cursor: pointer" class="sort" key="tarefa" data-sort="titulo" @click="onSort('tarefa')">Título</th>

              <th class="d-none d-lg-table-cell" key="categoria" data-sort="categoria">Categoria</th>
              <th class="sort d-none d-lg-table-cell" style="cursor: pointer" @click="onSort('prioridade')">Prioridade</th>
              <th class="sort d-none d-lg-table-cell" style="cursor: pointer" @click="onSort('status')">Status</th>
              <th class="sort d-none d-lg-table-cell" style="cursor: pointer" key="createdAt" data-sort="createdAt" @click="onSort('createdAt')">Data Abertura</th>
              <th class="sort d-none d-lg-table-cell" style="cursor: pointer" key="updatedAt" data-sort="updatedAt" @click="onSort('updatedAt')">Últ. Atua.</th>
              <th class="d-none d-lg-table-cell">Ações</th>
            </tr>
            </thead>

            <tbody v-if="loading">
            <tr>
              <td style="text-align: center" colspan="100%">
                <BSpinner type="grow" variant="primary"></BSpinner>
              </td>
            </tr>
            </tbody>

            <tbody v-else class="list form-check-all">
            <template v-for="(dt, index) of chamadosVisiveis" :key="index">
              <tr :class="{ 'chamado-linha-novidade': temNovidade(dt) }">
                <td class="d-lg-none">
                  <button class="btn btn-sm btn-soft-primary" @click="dt.expanded = !dt.expanded">
                    <i :class="dt.expanded ? 'ri-subtract-line' : 'ri-add-line'"></i>
                  </button>
                </td>

                <td>
                  <span class="text-primary" style="cursor: pointer; font-weight:500" @click="editEvent(dt)">{{dt.id}}</span>
                  <span
                    v-if="temNovidade(dt)"
                    class="chamado-ponto-novidade"
                    aria-label="Chamado com resposta não lida"
                  ></span>
                </td>
                <td style="max-width: 250px;">
                  <div class="text-truncate-two-lines" v-b-tooltip.hover :title="dt.tarefa">
                    <span class="text-primary" style="cursor: pointer; font-weight:500" @click="editEvent(dt)">{{dt.tarefa}}</span>
                  </div>
                  <span
                    v-if="temNovidade(dt)"
                    class="badge chamado-badge-novidade mt-1"
                    v-b-tooltip.hover
                    :title="tituloNovidade(dt)"
                  >
                    <i class="ri-chat-3-fill me-1"></i>{{ rotuloNovidade(dt) }}
                  </span>
                  <span
                    v-else-if="ultimaInteracao(dt)"
                    class="chamado-ultima-interacao mt-1"
                  >
                    <i class="ri-chat-check-line me-1"></i>Respondido em {{ moment(ultimaInteracao(dt)).format('DD/MM/YY') }}
                  </span>
                </td>

                <td class="d-none d-lg-table-cell"><span class="badge bg-primary mx-1 fs-6">{{getCategoria(dt.Categoria)}}</span></td>
                <td class="d-none d-lg-table-cell"><span :class="`badge ${badgePrioridade(dt.prioridade)} fs-6`">{{dt.prioridade}}</span></td>
                <td class="d-none d-lg-table-cell"><span :class="`badge ${badgeStatus(dt.status)} fs-6`">{{dt.status}}</span></td>
                <td class="d-none d-lg-table-cell">{{moment(dt.createdAt).format('DD/MM/YY HH:mm')}}</td>
                <td class="d-none d-lg-table-cell">{{moment(dt.updatedAt).format('DD/MM/YY HH:mm')}}</td>
                <td class="d-none d-lg-table-cell">
                  <div class="d-flex flex-wrap gap-2">
                    <BButton
                      size="sm"
                      variant="primary"
                      title="Abrir chamado"
                      @click="editEvent(dt)"
                    >
                      <i class="ri-eye-line align-bottom me-1"></i>Abrir
                    </BButton>
                    <BButton
                      class="btn btn-outline-warning btn-border"
                      v-if="isStatusSolucionada(dt.status)"
                      size="sm"
                      variant="soft-warning"
                      @click="validarSolucaoGrid(dt)"
                    >
                      Validar solução
                    </BButton>
                    <BButton
                      class="btn btn-outline-secondary btn-border"
                      v-if="isPesquisaPendente(dt)"
                      size="sm"
                      variant="soft-secondary"
                      @click="responderPesquisaPendenteGrid(dt)"
                    >
                      Responder pesquisa
                    </BButton>
                  </div>
                </td>
              </tr>

              <tr v-if="dt.expanded" class="d-lg-none bg-light">
                <td colspan="100%">
                  <div class="p-3 text-wrap">
                    <div class="row g-2">
                      <div v-if="temNovidade(dt)" class="col-12">
                        <div class="chamado-alerta-novidade">
                          <i class="ri-chat-3-fill me-1"></i>
                          <span>{{ tituloNovidade(dt) }}</span>
                        </div>
                      </div>
                      <div class="col-12 mb-2">
                        <BButton size="sm" variant="primary" block class="w-100" @click="editEvent(dt)">
                          <i class="ri-eye-line me-1"></i> Ver Detalhes / Editar
                        </BButton>
                      </div>
                      <div class="col-6">
                        <strong>Status:</strong><br>
                        <span :class="`badge ${badgeStatus(dt.status)}`">{{dt.status}}</span>
                      </div>
                      <div class="col-6">
                        <strong>Prioridade:</strong><br>
                        <span :class="`badge ${badgePrioridade(dt.prioridade)}`">{{dt.prioridade}}</span>
                      </div>
                      <div class="col-12">
                        <strong>Categoria:</strong><br>
                        {{getCategoria(dt.Categoria)}}
                      </div>
                      <div class="col-6">
                        <strong>Abertura:</strong><br>
                        {{moment(dt.createdAt).format('DD/MM/YY HH:mm')}}
                      </div>
                      <div class="col-6">
                        <strong>Atualização:</strong><br>
                        {{moment(dt.updatedAt).format('DD/MM/YY HH:mm')}}
                      </div>
                      <div v-if="temAcoesChamado(dt)" class="col-12 mt-2">
                        <div class="d-flex flex-column gap-2">
                          <BButton v-if="isStatusSolucionada(dt.status)" size="sm" variant="soft-warning" class="w-100" @click="validarSolucaoGrid(dt)">
                            Validar solução
                          </BButton>
                          <BButton v-if="isPesquisaPendente(dt)" size="sm" variant="soft-secondary" class="w-100" @click="responderPesquisaPendenteGrid(dt)">
                            Responder pesquisa
                          </BButton>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </template>
            </tbody>
          </table>
          <div class="d-flex flex-column flex-md-row justify-content-between align-items-center mt-3 mb-3 gap-3">

            <div class="pagination-wrap hstack gap-2 justify-content-center justify-content-md-start">
              <p v-if="!loading">&nbsp; {{ totalFiltered }} Registro(s) encontrado(s)</p>
            </div>

            <div v-if="loading" class="spinner-border text-primary" role="status"></div>

            <div v-else class="pagination-wrap hstack gap-2 justify-content-center justify-content-md-end">
              <BLink class="page-item pagination-prev" href="#" :disabled="page === 1" @click.prevent="page = 1">
                <span class="d-none d-lg-inline">Primeira página</span>
                <span class="d-lg-none">&lt;&lt;</span>
              </BLink>
              <BLink class="page-item pagination-prev" href="#" :disabled="page <= 1" @click.prevent="page--">
                <span class="d-none d-lg-inline">Anterior</span>
                <span class="d-lg-none">&lt;</span>
              </BLink>

              <ul class="pagination listjs-pagination mb-0 d-flex flex-wrap justify-content-center">
                <li v-for="(pageNumber, index) of pages" :key="index"
                    :class="{ active: typeof pageNumber === 'number' && pageNumber === page, disabled: pageNumber === '...', }">
                  <BLink class="page" href="#" @click.prevent="typeof pageNumber === 'number' ? page = pageNumber : null">
                    {{ pageNumber }}
                  </BLink>
                </li>
              </ul>

              <BLink class="page-item pagination-next" href="#" :disabled="page >= totalPages" @click.prevent="page++">
                <span class="d-none d-lg-inline">Seguinte</span>
                <span class="d-lg-none">&gt;</span>
              </BLink>
              <BLink class="page-item pagination-next" href="#" :disabled="page >= totalPages" @click.prevent="page = totalPages">
                <span class="d-none d-lg-inline">Última página</span>
                <span class="d-lg-none">&gt;&gt;</span>
              </BLink>
            </div>
          </div>
          <br>
        </div>
      </div>

      <div class="tab-pane" id="productnav-published" role="tabpanel">
        <div id="table-product-list-published" class="table-card gridjs-border-none"></div>
      </div>

      <div class="tab-pane" id="productnav-draft" role="tabpanel">
        <div class="py-4 text-center">
          <div class="mt-4">
            <h5>Desculpe, nenhum registro encontrado!</h5>
          </div>
        </div>
      </div>
    </div>
  </AppHero>
  <div class="d-block d-xxl-none position-fixed bottom-0 end-0 m-3" style="z-index: 1050;">
    <BButton
        variant="primary"
        class="rounded-circle shadow-lg d-flex align-items-center justify-content-center"
        style="width: 60px; height: 60px;"
        @click="openNovoChamado">
      <i class="ri-add-line" style="font-size: 28px;"></i>
    </BButton>
  </div>
  <BModal
      no-close-on-backdrop
      size="xl" v-model="modalShow"
      :title="edit && edit.all?`Chamado #${edit.all.id}`:'Novo Chamado'"
      header-close-class="text-white bg-white"
      title-class="text-white font-18"
      body-class="p-4"
      header-class="p-3 bg-primary"
      hide-footer
      class="v-modal-custom"
      centered
      dialog-class="modal-xxl modal-fullscreen-lg-down"
      @shown="onNovoChamadoModalShown"
      @hidden="onNovoChamadoModalHidden"
  >
    <novo-chamado
      :key="novoChamadoRenderKey"
      :historico-chamados="Array.isArray(results?.data) ? results.data : []"
      :modal-aberto="novoChamadoModalVisivel"
      @createEvent="createEvent"
    />
    <!--
    <form-tarefa
        :data="edit"
        :key="'kb'+Number(edit.id)"
        @createEvent="createEvent"
        @updateEvent="updateEvent"
        @deleteEvent="confirm"
    />
    -->
  </BModal>
  <BModal v-if="edit && edit.all"
      no-close-on-backdrop
      size="xl" v-model="modalShow2"
      :title="`Chamado #${edit.all.id} - ${edit.all.tarefa}`"
      header-close-class="text-white bg-white"
      title-class="text-white font-18"
      body-class="p-4"
      header-class="p-3 bg-primary"
      hide-footer
      class="v-modal-custom"
      centered
      dialog-class="modal-xxl modal-fullscreen-lg-down"
  >
    <form-tarefa
        :data="edit"
        :key="'kb'+Number(edit.id)"
        @updateEvent="updateEvent"
        @canceladoEvent="canceladoEvent"
    />
  </BModal>
  <div v-if="loadingPesquisaContador > 0" class="loading-overlay-pesquisa">
    <div class="loading-overlay-pesquisa-box">
      <BSpinner variant="primary" />
      <span>Carregando...</span>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { defineAsyncComponent } from "vue";
import Swal from "sweetalert2";
import { sucesso, aviso, erro } from "../../../helpers/mirai/custom";
import moment from "moment";

const NovoChamado = defineAsyncComponent(() => import("@/views/mirai/dashboard/novoChamado.vue"));
const FormTarefa = defineAsyncComponent(() => import("@/views/mirai/dashboard/formTarefa.vue"));

export default {
  name: "chamado",
  components: {
    FormTarefa,
    NovoChamado
  },
  props:{
    changeRadio: Function
  },
  // `nao-lidos` mantém o aviso do painel em sincronia: quem lê um chamado aqui
  // precisa ver o contador do topo cair na mesma hora.
  emits: ["createEvent", "nao-lidos"],
  data(){
    return {
      loading:false,
      page: 1,
      pages:[],
      perPage:20,
      query:'',
      lastquery:'',
      timeout:null,
      results:[],
      user:localStorage.getItem("userid"),
      userData: JSON.parse(localStorage.getItem("userdata") || "{}"),
      edit:{},
      editevent:{},
      modalShow: false,
      modalShow2: false,
      interval:false,
      novoChamadoRenderKey: 0,
      novoChamadoModalVisivel: false,
      pesquisaRespondidaPorTarefa: {},
      pesquisaPendentePorTarefa: {},
      pendenciasPesquisa: [],
      pendenciasPesquisaCarregando: false,
      pendenciasPesquisaPromptExibido: false,
      loadingPesquisaContador: 0,
      // Interações da equipe por chamado: { [id]: { ultima_interacao_em, novas, nao_lido } }
      interacoes: {},
      totalNaoLidos: 0,
      apenasNovidades: false,
    }
  },
  created() {
  },
  async mounted() {
    if(this.$route.query.abreChamado){
      this.openNovoChamado();
    }
    if(this.$route.query.chamado){
      this.query = this.$route.query.chamado;
      const id = this.$route.query.chamado;
     const result = await axios.get(`/tarefa/data?where={"finalidade":"chamado","id":${id}}`);
     if(result && result?.data.data){
       this.edit.all = result.data.data[0];
     }

      this.modalShow2 = true;
    }
    await this.getDatabase();
    await this.sincronizarPendenciasPesquisa({ mostrarPrompt: true });
  },
  beforeUnmount() {
    clearInterval(this.interval);
  },
  computed: {
    moment() {
      return moment
    },
    totalFiltered() {
      const total = Number(this.results?.filtered ?? this.results?.count ?? 0);
      return Number.isFinite(total) && total > 0 ? total : 0;
    },
    totalPages() {
      const pages = Math.ceil(this.totalFiltered / this.perPage);
      return Number.isFinite(pages) && pages > 0 ? pages : 1;
    },
    // O filtro "com resposta nova" age só sobre a página carregada: é um
    // atalho visual, não um recorte de servidor (que mudaria a paginação).
    chamadosVisiveis() {
      const lista = Array.isArray(this.results?.data) ? this.results.data : [];
      if (!this.apenasNovidades) return lista;
      return lista.filter((item) => this.temNovidade(item));
    }
  },
  methods: {
    iniciarLoadingPesquisa() {
      this.loadingPesquisaContador = Number(this.loadingPesquisaContador || 0) + 1;
    },
    finalizarLoadingPesquisa() {
      this.loadingPesquisaContador = Math.max(
        0,
        Number(this.loadingPesquisaContador || 0) - 1,
      );
    },
    async executarComLoadingPesquisa(handler) {
      if (typeof handler !== "function") return null;
      this.iniciarLoadingPesquisa();
      try {
        return await handler();
      } finally {
        this.finalizarLoadingPesquisa();
      }
    },
    openNovoChamado() {
      this.edit = {};
      this.novoChamadoRenderKey += 1;
      this.novoChamadoModalVisivel = false;
      this.modalShow = true;
    },
    onNovoChamadoModalShown() {
      this.novoChamadoModalVisivel = true;
    },
    onNovoChamadoModalHidden() {
      this.novoChamadoModalVisivel = false;
    },
    resolverChamadoAtualizado(chamado, { statusFallback = null } = {}) {
      const id = this.getChamadoId(chamado);
      const chamadosDaPagina = Array.isArray(this.results?.data) ? this.results.data : [];
      const atualizado = id ? chamadosDaPagina.find((item) => this.getChamadoId(item) === id) : null;
      const base = atualizado || chamado || {};
      return {
        ...base,
        id: id || base.id || null,
        status: statusFallback || base.status || chamado?.status || null,
      };
    },
    badgePrioridade(data){
      if(data.toLowerCase() === "baixa"){
        return "border border-primary bg-info-subtle text-primary"
      }
      else if(data.toLowerCase() === "média" || data.toLowerCase() === "media"){
        return "border border-warning bg-orange-subtle text-orange"
      }
      else if(data.toLowerCase() === "alta"){
        return "border border-orange bg-danger-subtle text-danger"
      }
      else if(data.toLowerCase() === "urgente"){
        return "border border-secondary bg-secondary-subtle text-secondary"
      }
    },
    badgeStatus(data){
      if(data.toLowerCase() === "nova"){
        return "bg-success-subtle text-success badge-border"
      }
      else if(data.toLowerCase() === "pendente"){
        return "bg-warning-subtle text-warning badge-border"
      }
      else if(data.toLowerCase() === "em execução"){
        return "bg-teal-subtle text-teal badge-border"
      }
      else if(data.toLowerCase() === "em revisão"){
        return "bg-secondary-subtle text-secondary badge-border"
      }
      else if(data.toLowerCase() === "finalizada"){
        return "bg-primary-subtle text-primary badge-border"
      }
      else if(data.toLowerCase() === "encerrada"){
        return "bg-info-subtle text-info badge-border"
      }
      else if(data.toLowerCase() === "solucionada"){
        return "bg-secondary-subtle text-secondary badge-border"
      }
      else if(data.toLowerCase() === "cancelada"){
        return "bg-danger-subtle text-danger badge-border"
      }
      else if(data.toLowerCase() === "adiada"){
        return "bg-orange-subtle text-orange badge-border"
      }
      else if(data.toLowerCase() === "arquivada"){
        return "bg-dark-subtle text-dark badge-border"
      }
    },
    normalizeStatus(status){
      return String(status || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase();
    },
    isStatusSolucionada(status){
      return this.normalizeStatus(status) === "solucionada";
    },
    isStatusFinalizada(status){
      return this.normalizeStatus(status) === "finalizada";
    },
    getChamadoId(chamado){
      const rawId = typeof chamado === "object" ? chamado?.id : chamado;
      const id = Number(rawId || 0);
      return Number.isFinite(id) && id > 0 ? id : null;
    },
    getDataAberturaChamado(chamado){
      if (!chamado || typeof chamado !== "object") return null;

      const candidatos = [
        chamado?.createdAt,
        chamado?.created_at,
        chamado?.dataAbertura,
        chamado?.data_abertura,
      ];

      for (const valor of candidatos) {
        if (!valor) continue;
        const data = new Date(valor);
        if (!Number.isNaN(data.getTime())) {
          return data;
        }
      }

      return null;
    },
    isChamadoElegivelPromptPesquisa(chamado){
      const dataAbertura = this.getDataAberturaChamado(chamado);
      if (!dataAbertura) return false;

      // Prompt automático ao abrir a tela apenas para chamados a partir de 03/03/2026.
      const limitePromptPesquisa = new Date(2026, 2, 3, 0, 0, 0, 0);
      return dataAbertura.getTime() >= limitePromptPesquisa.getTime();
    },
    getAccountnamePesquisa(){
      return String(this.userData?.usuario || this.user || "").trim();
    },
    isPesquisaPendente(chamado){
      const id = this.getChamadoId(chamado);
      if (!id) return false;

      if (Object.prototype.hasOwnProperty.call(this.pesquisaPendentePorTarefa, id)) {
        return Boolean(this.pesquisaPendentePorTarefa[id]);
      }

      return this.isStatusFinalizada(chamado?.status) && !this.pesquisaRespondidaPorTarefa[id];
    },
    temAcoesChamado(chamado){
      return this.isStatusSolucionada(chamado?.status) || this.isPesquisaPendente(chamado);
    },
    marcarPesquisaRespondidaLocal(chamadoId){
      const id = this.getChamadoId(chamadoId);
      if (!id) return;

      this.pesquisaRespondidaPorTarefa = {
        ...this.pesquisaRespondidaPorTarefa,
        [id]: true,
      };

      if (Object.prototype.hasOwnProperty.call(this.pesquisaPendentePorTarefa, id)) {
        const pendentesMap = { ...this.pesquisaPendentePorTarefa };
        delete pendentesMap[id];
        this.pesquisaPendentePorTarefa = pendentesMap;
      }

      this.pendenciasPesquisa = (Array.isArray(this.pendenciasPesquisa) ? this.pendenciasPesquisa : [])
        .filter((item) => this.getChamadoId(item) !== id);
    },
    marcarPesquisaPendenteLocal(chamado){
      const id = this.getChamadoId(chamado);
      if (!id) return;
      if (!this.isStatusFinalizada(chamado?.status)) return;

      this.pesquisaPendentePorTarefa = {
        ...this.pesquisaPendentePorTarefa,
        [id]: true,
      };

      const listaAtual = Array.isArray(this.pendenciasPesquisa) ? this.pendenciasPesquisa : [];
      const existe = listaAtual.some((item) => this.getChamadoId(item) === id);
      if (!existe) {
        this.pendenciasPesquisa = [chamado, ...listaAtual];
      }
    },
    comentarioEhDoUsuario(comentario){
      if (!comentario) return false;
      if (comentario?.TarefaUsuario?.id === 0) return true;
      return Boolean(
        comentario?.accountname &&
        this.userData?.usuario &&
        comentario.accountname === this.userData.usuario
      );
    },
    getUltimoComentarioOperador(chamado){
      const lista = Array.isArray(chamado?.TarefaComentario) ? [...chamado.TarefaComentario] : [];
      if (!lista.length) return null;
      lista.sort((a, b) => new Date(a.createdAt || 0) - new Date(b.createdAt || 0));
      for (let index = lista.length - 1; index >= 0; index -= 1) {
        const comentario = lista[index];
        if (!this.comentarioEhDoUsuario(comentario)) {
          return comentario;
        }
      }
      return null;
    },
    getUltimoOperadorPesquisa(chamado){
      const comentarioOperador = this.getUltimoComentarioOperador(chamado);
      if (!comentarioOperador) {
        return { id: 0, nome: null };
      }

      const operadorId = Number(
        comentarioOperador?.TarefaUsuario?.id ||
        comentarioOperador?.usuario ||
        0,
      );
      const operadorNome = String(
        comentarioOperador?.TarefaUsuario?.nome ||
        comentarioOperador?.accountname ||
        "",
      ).trim();

      return {
        id: Number.isFinite(operadorId) && operadorId > 0 ? operadorId : 0,
        nome: operadorNome.length > 0 ? operadorNome : null,
      };
    },
    async validarSolucaoGrid(chamado){
      const ultimoComentario = this.getUltimoComentarioOperador(chamado);
      let html = `<p class="mb-0">A solução proposta resolveu o problema?</p>`;

      if (ultimoComentario?.comentario) {
        const tecnico = String(
          ultimoComentario?.TarefaUsuario?.nome ||
          ultimoComentario?.accountname ||
          "Especialista não identificado",
        ).trim();
        html = `
          <p class="mb-2"><b>Último comentário do especialista:</b> ${this.escapeHtml(tecnico)}</p>
          <div class="alert alert-info text-start">${ultimoComentario.comentario}</div>
          <p class="mb-0">A solução proposta resolveu o problema?</p>
        `;
      }

      try{
        const result = await Swal.fire({
          icon: "warning",
          title: "Confirmação de solução",
          html,
          showDenyButton: true,
          showCancelButton: false,
          allowOutsideClick: false,
          allowEscapeKey: false,
          showCloseButton: false,
          confirmButtonText: "Sim, resolveu",
          denyButtonText: "Não resolveu",
        });

        if (result.isConfirmed) {
          await this.executarComLoadingPesquisa(async () =>
            axios.put(`/tarefa/${chamado.id}`, { usuario: 0, status: "Finalizada" }),
          );
          await this.getDatabase({offset:((this.page-1)*this.perPage)});
          const chamadoFinalizado = this.resolverChamadoAtualizado(chamado, { statusFallback: "Finalizada" });
          await this.abrirPesquisaSatisfacao(chamadoFinalizado, { showCancelFeedback: true });
          await this.sincronizarPendenciasPesquisa();
          return;
        }

        // "Não resolveu": exige assentamento (motivo) antes de reabrir o chamado.
        const motivoResult = await Swal.fire({
          icon: "question",
          title: "Motivo da recusa",
          html: `<p class="mb-2 text-start">Explique por que a solução proposta não resolveu o problema. Essa justificativa será enviada ao técnico responsável.</p>`,
          input: "textarea",
          inputPlaceholder: "Descreva o motivo da recusa...",
          showCancelButton: true,
          allowOutsideClick: false,
          allowEscapeKey: false,
          confirmButtonText: "Confirmar recusa",
          cancelButtonText: "Voltar",
          inputValidator: (value) => {
            if (!value || !value.trim()) {
              return "Informe o motivo da recusa para continuar.";
            }
          },
        });

        if (!motivoResult.isConfirmed) {
          return;
        }

        const motivoTexto = motivoResult.value.trim();

        const comentario = {
          cId: chamado.id + "." + (chamado.TarefaComentario ? chamado.TarefaComentario.length + 1 : 0),
          tarefa: chamado.id,
          comentario: `${this.userData?.nome || "Usuário"} informou que a solução proposta não resolveu o problema. Motivo: ${motivoTexto}`,
          usuario: 0,
          accountname: this.userData?.usuario,
          TarefaUsuario: { nome: this.userData?.nome || "Usuário", id: 0 },
        };
        await this.executarComLoadingPesquisa(async () =>
          axios.put(`/tarefa/${chamado.id}`, {
            usuario: 0,
            status: "Pendente",
            TarefaComentario: [comentario],
          }),
        );
        await this.getDatabase({offset:((this.page-1)*this.perPage)});
        await this.sincronizarPendenciasPesquisa();
        aviso({
          title: "Chamado reaberto, nosso time entrará em contato com você em breve!",
          showConfirmButton: true,
          timer: false
        });
      }catch (e){
        erro({ title: e.response?.data?.error || e.message || "Não foi possível validar a solução agora." });
      }
    },
    async responderPesquisaPendenteGrid(chamado){
      const chamadoAtualizado = this.resolverChamadoAtualizado(chamado, { statusFallback: "Finalizada" });
      await this.abrirPesquisaSatisfacao(chamadoAtualizado, {
        showCancelFeedback: true,
        pendenciaIndex: 1,
        pendenciaTotal: 1,
      });
      await this.sincronizarPendenciasPesquisa();
    },
    escapeHtml(value) {
      return String(value || "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;");
    },
    normalizarComentarioTexto(value) {
      return String(value || "")
        .replace(/<br\s*\/?>/gi, "\n")
        .replace(/<\/p>/gi, "\n")
        .replace(/<[^>]+>/g, " ")
        .replace(/&nbsp;/gi, " ")
        .replace(/&amp;/gi, "&")
        .replace(/&lt;/gi, "<")
        .replace(/&gt;/gi, ">")
        .replace(/\r\n/g, "\n")
        .replace(/[ \t]+\n/g, "\n")
        .replace(/\n{3,}/g, "\n\n")
        .replace(/[ \t]{2,}/g, " ")
        .trim();
    },
    textoParaHtml(value) {
      return this.escapeHtml(value).replace(/\n/g, "<br>");
    },
    getPesquisaChamadoInfo(chamado) {
      const id = this.getChamadoId(chamado);
      const tarefaRaw = String(chamado?.tarefa || chamado?.all?.tarefa || "").trim();
      const tarefa = tarefaRaw.length > 0 ? tarefaRaw : "Sem descrição informada.";
      const ultimoComentario = this.getUltimoComentarioOperador(chamado);
      const tecnicoNomeRaw = String(
        ultimoComentario?.TarefaUsuario?.nome ||
        ultimoComentario?.accountname ||
        "",
      ).trim();
      const tecnicoNome = tecnicoNomeRaw.length > 0 ? tecnicoNomeRaw : null;
      const solucaoTextoRaw = this.normalizarComentarioTexto(ultimoComentario?.comentario || "");
      const solucaoTexto = solucaoTextoRaw.length > 0 ? solucaoTextoRaw : null;
      const solucaoData = ultimoComentario?.createdAt
        ? moment(ultimoComentario.createdAt).format("DD/MM/YYYY HH:mm")
        : null;

      return {
        id: id || "-",
        tarefa,
        tecnicoNome,
        solucaoTexto,
        solucaoData,
      };
    },
    buildPesquisaSatisfacaoHtml(chamado, { pendenciaIndex = null, pendenciaTotal = null } = {}) {
      const info = this.getPesquisaChamadoInfo(chamado);
      const mostrarSequencia = Number(pendenciaTotal || 0) > 1;
      const sequenciaHtml = mostrarSequencia
        ? `<div class="survey-context-progress">Pesquisa ${Number(pendenciaIndex || 1)} de ${Number(pendenciaTotal)}</div>`
        : "";
      const tarefaEscapada = this.escapeHtml(info.tarefa);
      const tecnicoEscapado = this.escapeHtml(info.tecnicoNome || "Não identificado");
      const solucaoEscapada = info.solucaoTexto ? this.textoParaHtml(info.solucaoTexto) : "";
      const solucaoDataEscapada = info.solucaoData ? this.escapeHtml(info.solucaoData) : "";
      const solucaoHtml = info.solucaoTexto
        ? `
            <div class="survey-context-solution">
              <div class="survey-context-solution-title">Solução registrada</div>
              <div class="survey-context-solution-meta">Especialista/Técnico: <b>${tecnicoEscapado}</b></div>
              ${info.solucaoData ? `<div class="survey-context-solution-meta">Atualizado em: ${solucaoDataEscapada}</div>` : ""}
              <div class="survey-context-solution-text">${solucaoEscapada}</div>
            </div>
          `
        : "";

      return `
        <style>
          .survey-wrap { text-align:left; }
          .survey-context {
            border: 1px solid #dbe7f8;
            background: #f8fbff;
            border-radius: 10px;
            padding: 10px 12px;
            margin-bottom: 12px;
          }
          .survey-context-progress {
            display: inline-block;
            font-size: 0.72rem;
            font-weight: 700;
            color: #475569;
            background: #e2e8f0;
            border-radius: 999px;
            padding: 2px 8px;
            margin-bottom: 6px;
          }
          .survey-context-ticket {
            font-size: 0.84rem;
            font-weight: 700;
            color: #1e3a8a;
            margin-bottom: 4px;
          }
          .survey-context-title {
            font-size: 0.82rem;
            color: #334155;
            line-height: 1.3;
            word-break: break-word;
          }
          .survey-context-solution {
            margin-top: 10px;
            border-top: 1px dashed #c9d7ed;
            padding-top: 8px;
          }
          .survey-context-solution-title {
            font-size: 0.78rem;
            font-weight: 700;
            color: #1f2937;
            margin-bottom: 4px;
            text-transform: uppercase;
            letter-spacing: 0.02em;
          }
          .survey-context-solution-meta {
            font-size: 0.75rem;
            color: #475569;
            margin-bottom: 4px;
          }
          .survey-context-solution-text {
            font-size: 0.8rem;
            color: #334155;
            line-height: 1.35;
            white-space: normal;
            word-break: break-word;
          }
          .survey-question { margin-bottom: 12px; }
          .survey-title { font-weight: 600; margin-bottom: 6px; color: #334155; }
          .survey-stars { display: flex; gap: 4px; }
          .rating-star {
            border: none;
            background: transparent;
            cursor: pointer;
            font-size: 1.45rem;
            color: #d1d5db;
            line-height: 1;
            padding: 0;
          }
          .rating-star.selected { color: #f59e0b; }
          .survey-hint { font-size: 0.82rem; color: #64748b; margin-top: 2px; }
          .survey-textarea {
            width: 100%;
            margin-top: 10px;
            border: 1px solid #cbd5e1;
            border-radius: 8px;
            padding: 10px;
            resize: vertical;
            min-height: 90px;
            font-size: 0.92rem;
          }
        </style>
        <div class="survey-wrap">
          <div class="survey-context">
            ${sequenciaHtml}
            <div class="survey-context-ticket">Chamado #${info.id}</div>
            <div class="survey-context-title">${tarefaEscapada}</div>
            ${solucaoHtml}
          </div>
          <div class="survey-question">
            <div class="survey-title">1. Como você avalia o atendimento prestado neste chamado?</div>
            <div class="survey-stars">${this.renderStars("q1")}</div>
            <input id="survey-q1" type="hidden" value="0">
          </div>
          <div class="survey-question">
            <div class="survey-title">2. Você está gostando de usar o CAU (Central de Atenção ao Usuário)?</div>
            <div class="survey-stars">${this.renderStars("q2")}</div>
            <input id="survey-q2" type="hidden" value="0">
          </div>
          <div class="survey-question">
            <div class="survey-title">3. Como você avalia a Secretaria de Tecnologia como um todo?</div>
            <div class="survey-stars">${this.renderStars("q3")}</div>
            <input id="survey-q3" type="hidden" value="0">
            <div class="survey-hint">Selecione de 1 a 5 estrelas em cada pergunta.</div>
            <textarea id="survey-comment" class="survey-textarea" placeholder="Deixe um comentário, sugestão ou reclamação, o seu feedback nos ajuda a melhorar cada vez mais! (opcional)."></textarea>
          </div>
        </div>
      `;
    },
    renderStars(questionId) {
      return [1, 2, 3, 4, 5]
        .map((value) => `<button type="button" class="rating-star" data-question="${questionId}" data-value="${value}">★</button>`)
        .join("");
    },
    bindPesquisaStars() {
      const container = Swal.getHtmlContainer();
      if (!container) return;

      const updateStars = (questionId, value) => {
        const input = container.querySelector(`#survey-${questionId}`);
        if (input) input.value = String(value);

        container
          .querySelectorAll(`.rating-star[data-question="${questionId}"]`)
          .forEach((star) => {
            star.classList.toggle("selected", Number(star.dataset.value) <= Number(value));
          });
      };

      container.querySelectorAll(".rating-star").forEach((star) => {
        star.addEventListener("click", () => {
          updateStars(star.dataset.question, Number(star.dataset.value));
        });
      });
    },
    async salvarPesquisaSatisfacao(chamado, respostas) {
      return this.executarComLoadingPesquisa(async () => {
        const nome = this.userData?.nome || "Usuário";
        const operador = this.getUltimoOperadorPesquisa(chamado);
        const comentarios = Array.isArray(chamado?.TarefaComentario) ? chamado.TarefaComentario : [];
        const cId = `${chamado.id}.${comentarios.length + 1}`;
        const comentarioLivre = String(respostas.comentario || "").trim();
        const comentarioLivreHtml = comentarioLivre
          ? this.escapeHtml(comentarioLivre).replace(/\n/g, "<br>")
          : "";
        await axios.post(`/pesquisa/responder`, {
          contexto: "chamado",
          tarefa: chamado.id,
          usuario: operador.id || 0,
          accountname: this.userData?.usuario || null,
          origem: "cau",
          comentario: comentarioLivre || null,
          respostas: {
            atendimento_prestado: respostas.q1,
            experiencia_cau: respostas.q2,
            avaliacao_secretaria_ti: respostas.q3,
            comentario_livre: comentarioLivre || null,
          },
          metadados: {
            origem: "modal_satisfacao",
            operadorSugeridoId: operador.id || null,
            operadorSugeridoNome: operador.nome || null,
          },
        });

        const comentario = {
          cId,
          tarefa: chamado.id,
          comentario:
            `<p><b>Pesquisa de satisfação (${nome}) enviada</b></p>` +
            `<p>1. Atendimento prestado: <b>${respostas.q1}/5</b></p>` +
            `<p>2. Experiência com o CAU: <b>${respostas.q2}/5</b></p>` +
            `<p>3. Avaliação da Secretaria de TI: <b>${respostas.q3}/5</b></p>` +
            (comentarioLivreHtml ? `<p>Comentário do usuário: ${comentarioLivreHtml}</p>` : ""),
          usuario: 0,
          accountname: this.userData?.usuario,
          TarefaUsuario: { nome, id: 0 },
        };

        await axios.put(`/tarefa/${chamado.id}`, { usuario: 0, TarefaComentario: [comentario] });
      });
    },
    async abrirPesquisaSatisfacao(
      chamado,
      { showCancelFeedback = false, pendenciaIndex = null, pendenciaTotal = null } = {},
    ) {
      const info = this.getPesquisaChamadoInfo(chamado);
      const result = await Swal.fire({
        title: `Pesquisa de satisfação - Chamado #${info.id}`,
        html: this.buildPesquisaSatisfacaoHtml(chamado, { pendenciaIndex, pendenciaTotal }),
        showCancelButton: true,
        confirmButtonText: "Enviar avaliação",
        cancelButtonText: "Responder depois",
        allowOutsideClick: false,
        didOpen: () => {
          this.bindPesquisaStars();
        },
        preConfirm: () => {
          const container = Swal.getHtmlContainer();
          const q1 = Number(container?.querySelector("#survey-q1")?.value || 0);
          const q2 = Number(container?.querySelector("#survey-q2")?.value || 0);
          const q3 = Number(container?.querySelector("#survey-q3")?.value || 0);
          const comentario = String(container?.querySelector("#survey-comment")?.value || "").trim();

          if (!q1 || !q2 || !q3) {
            Swal.showValidationMessage("Responda as 3 perguntas para enviar a avaliação.");
            return false;
          }

          return { q1, q2, q3, comentario };
        },
      });

      if (!result.isConfirmed || !result.value) {
        this.marcarPesquisaPendenteLocal(chamado);
        if (showCancelFeedback) {
          aviso({
            title: "Você pode responder depois em Ações.",
            showConfirmButton: true,
            timer: 3500,
          });
        }
        return { status: "cancelada" };
      }

      try {
        await this.salvarPesquisaSatisfacao(chamado, result.value);
        this.marcarPesquisaRespondidaLocal(chamado?.id);
        aviso({
          icon:"success",
          title: "Obrigado! Sua avaliação foi enviada com sucesso.",
          showConfirmButton: true,
          timer: false,
        });
        return { status: "enviada" };
      } catch (e) {
        erro({
          title:
            e.response?.data?.error ||
            e.message ||
            "Não foi possível registrar sua avaliação agora.",
        });
        return { status: "erro" };
      }
    },
    async carregarRespostasPesquisaUsuario({ limitePagina = 200, limiteMaximo = 5000 } = {}) {
      return this.executarComLoadingPesquisa(async () => {
        const accountname = this.getAccountnamePesquisa();
        if (!accountname) return [];

        const respostas = [];
        let offset = 0;
        let total = null;

        while (offset < limiteMaximo) {
          const result = await axios.get("/pesquisa/relatorio", {
            params: {
              accountname,
              limit: limitePagina,
              offset,
            },
          });

          const data = Array.isArray(result?.data?.data) ? result.data.data : [];
          if (data.length === 0) break;

          respostas.push(...data);
          const count = Number(result?.data?.filtered ?? result?.data?.total ?? result?.data?.count ?? 0);
          total = Number.isFinite(count) ? count : null;

          offset += data.length;
          if (data.length < limitePagina) break;
          if (total !== null && offset >= total) break;
        }

        return respostas;
      });
    },
    construirMapaPesquisaRespondida(respostas = []) {
      const mapa = {};

      respostas.forEach((item) => {
        const contextoPesquisa = this.normalizeStatus(item?.Pesquisa?.contexto || "chamado");
        if (contextoPesquisa && contextoPesquisa !== "chamado") return;

        const tarefaId = this.getChamadoId(item?.tarefa);
        if (!tarefaId) return;
        mapa[tarefaId] = true;
      });

      return mapa;
    },
    async carregarChamadosFinalizadosUsuario({ limitePagina = 200, limiteMaximo = 2000 } = {}) {
      return this.executarComLoadingPesquisa(async () => {
        const accountname = String(this.user || "").trim();
        if (!accountname) return [];

        const chamados = [];
        let offset = 0;
        let total = null;

        while (offset < limiteMaximo) {
          const result = await axios.get("/tarefa/data", {
            params: {
              limit: limitePagina,
              offset,
              where: JSON.stringify({
                finalidade: "chamado",
                accountname,
                status: ["Finalizada"],
              }),
            },
          });

          const data = Array.isArray(result?.data?.data) ? result.data.data : [];
          if (data.length === 0) break;

          chamados.push(...data);
          const count = Number(result?.data?.filtered ?? result?.data?.total ?? result?.data?.count ?? 0);
          total = Number.isFinite(count) ? count : null;

          offset += data.length;
          if (data.length < limitePagina) break;
          if (total !== null && offset >= total) break;
        }

        if (chamados.length > limiteMaximo) {
          return chamados.slice(0, limiteMaximo);
        }
        return chamados;
      });
    },
    mapearPendenciasPesquisa(chamados = [], mapaRespondidas = {}) {
      const pendentes = [];
      const pendentesMap = {};
      const seen = new Set();

      chamados.forEach((chamado) => {
        const id = this.getChamadoId(chamado);
        if (!id || seen.has(id)) return;
        seen.add(id);

        const pendente = this.isStatusFinalizada(chamado?.status) && !mapaRespondidas[id];
        if (!pendente) return;

        pendentesMap[id] = true;
        pendentes.push(chamado);
      });

      pendentes.sort((a, b) => Number(b?.id || 0) - Number(a?.id || 0));
      return { pendentes, pendentesMap };
    },
    recalcularPendenciasDaPagina() {
      const pagina = Array.isArray(this.results?.data) ? this.results.data : [];
      if (!pagina.length) return;

      const pendentesMap = { ...this.pesquisaPendentePorTarefa };
      pagina.forEach((chamado) => {
        const id = this.getChamadoId(chamado);
        if (!id) return;

        if (this.isStatusFinalizada(chamado?.status) && !this.pesquisaRespondidaPorTarefa[id]) {
          pendentesMap[id] = true;
        } else {
          delete pendentesMap[id];
        }
      });

      this.pesquisaPendentePorTarefa = pendentesMap;
    },
    async perguntarPendenciasPesquisaNoLogin() {
      if (this.pendenciasPesquisaPromptExibido) return;
      const pendentes = Array.isArray(this.pendenciasPesquisa) ? this.pendenciasPesquisa : [];
      const pendentesElegiveisPrompt = pendentes
        .filter((chamado) => this.isPesquisaPendente(chamado))
        .filter((chamado) => this.isChamadoElegivelPromptPesquisa(chamado));
      if (pendentesElegiveisPrompt.length === 0) return;

      this.pendenciasPesquisaPromptExibido = true;
      const result = await Swal.fire({
        icon: "info",
        title: "Pesquisas de satisfação pendentes",
        html: `Você possui <b>${pendentesElegiveisPrompt.length}</b> pesquisa(s) pendente(s). Deseja responder agora?`,
        showCancelButton: true,
        confirmButtonText: "Responder agora",
        cancelButtonText: "Responder depois",
        allowOutsideClick: false,
      });

      if (!result.isConfirmed) return;
      await this.responderPesquisasPendentesNoLogin({ listaBase: pendentesElegiveisPrompt });
    },
    async responderPesquisasPendentesNoLogin({ listaBase = null } = {}) {
      const origem = Array.isArray(listaBase)
        ? [...listaBase]
        : (Array.isArray(this.pendenciasPesquisa) ? [...this.pendenciasPesquisa] : []);
      const pendentes = origem
        .filter((chamado) => this.isPesquisaPendente(chamado));

      for (let index = 0; index < pendentes.length; index += 1) {
        const chamado = this.resolverChamadoAtualizado(pendentes[index], { statusFallback: "Finalizada" });
        const resultado = await this.abrirPesquisaSatisfacao(chamado, {
          showCancelFeedback: false,
          pendenciaIndex: index + 1,
          pendenciaTotal: pendentes.length,
        });
        if (resultado?.status !== "enviada") break;
      }
    },
    async sincronizarPendenciasPesquisa({ mostrarPrompt = false } = {}) {
      if (this.pendenciasPesquisaCarregando) return;
      this.pendenciasPesquisaCarregando = true;

      try {
        const [respostas, chamadosFinalizados] = await Promise.all([
          this.carregarRespostasPesquisaUsuario(),
          this.carregarChamadosFinalizadosUsuario(),
        ]);

        const mapaRespondidas = this.construirMapaPesquisaRespondida(respostas);
        this.pesquisaRespondidaPorTarefa = mapaRespondidas;

        const { pendentes, pendentesMap } = this.mapearPendenciasPesquisa(chamadosFinalizados, mapaRespondidas);
        this.pendenciasPesquisa = pendentes;
        this.pesquisaPendentePorTarefa = pendentesMap;
        this.recalcularPendenciasDaPagina();

        if (mostrarPrompt) {
          await this.perguntarPendenciasPesquisaNoLogin();
        }
      } catch (e) {
        console.error("Não foi possível carregar pendências de pesquisa:", e?.response?.data || e);
      } finally {
        this.pendenciasPesquisaCarregando = false;
      }
    },
    /**
     * Interações da equipe nos chamados da página.
     *
     * Não dá para inferir isso de `updatedAt`: mudança de fila ou de prioridade
     * também mexe nessa data sem que nada tenha sido respondido ao solicitante.
     * O backend compara os comentários de terceiros com a marca de leitura.
     */
    async carregarInteracoes() {
      const ids = (Array.isArray(this.results?.data) ? this.results.data : [])
        .map((item) => Number(item?.id || 0))
        .filter((id) => Number.isFinite(id) && id > 0);

      if (ids.length === 0) {
        this.interacoes = {};
        this.definirTotalNaoLidos(0);
        return;
      }

      try {
        const resposta = await axios.get("/tarefa/interacoes", {
          params: { ids: ids.join(",") },
        });
        this.interacoes = resposta.data?.itens || {};
        this.definirTotalNaoLidos(resposta.data?.total_nao_lidos);
      } catch (e) {
        // Sinalização é acessório: falhar aqui não pode esconder a lista.
        this.interacoes = {};
        this.definirTotalNaoLidos(0);
      }
    },
    definirTotalNaoLidos(valor) {
      const total = Math.max(0, Number(valor || 0));
      this.totalNaoLidos = total;
      if (total === 0) this.apenasNovidades = false;
      this.$emit("nao-lidos", total);
    },
    interacaoDe(chamado) {
      const id = Number(chamado?.id || 0);
      if (!id) return null;
      return this.interacoes?.[id] || this.interacoes?.[String(id)] || null;
    },
    temNovidade(chamado) {
      return Boolean(this.interacaoDe(chamado)?.nao_lido);
    },
    ultimaInteracao(chamado) {
      return this.interacaoDe(chamado)?.ultima_interacao_em || null;
    },
    rotuloNovidade(chamado) {
      const novas = Number(this.interacaoDe(chamado)?.novas || 0);
      return novas > 1 ? `${novas} respostas novas` : "Resposta nova";
    },
    tituloNovidade(chamado) {
      const data = this.ultimaInteracao(chamado);
      const quando = data ? moment(data).format("DD/MM/YY [às] HH:mm") : "";
      return quando
        ? `${this.rotuloNovidade(chamado)} — última em ${quando}. Abra o chamado para ler.`
        : `${this.rotuloNovidade(chamado)}. Abra o chamado para ler.`;
    },
    async marcarComoLido(chamado) {
      const id = Number(chamado?.id || 0);
      if (!id || !this.temNovidade(chamado)) return;

      // Atualiza a tela na hora: o usuário acabou de abrir o chamado.
      const atual = this.interacaoDe(chamado);
      this.interacoes = {
        ...this.interacoes,
        [id]: { ...atual, novas: 0, nao_lido: false },
      };
      this.definirTotalNaoLidos(Number(this.totalNaoLidos || 0) - 1);

      try {
        await axios.post("/tarefa/leitura", { tarefa_id: id });
      } catch (e) {
        // Se a marca não gravar, a próxima carga traz o destaque de volta.
        console.error(e);
      }
    },
    async editEvent(info){
      this.edit.all = info;
      this.modalShow2 = true;
      await this.marcarComoLido(info);
    },
    /**
     * Cancelamento feito pelo solicitante no formulário.
     *
     * Tem tratamento próprio (e não `updateEvent`) porque aquele fluxo notifica
     * a fila como "nova mensagem" e emite um segundo toast de sucesso — nada
     * disso cabe aqui. O feedback já foi dado no formulário.
     */
    async canceladoEvent(chamado){
      const id = Number(chamado?.id || 0);
      const indice = this.results?.data?.findIndex?.((item) => Number(item.id) === id);
      if (Number.isInteger(indice) && indice >= 0) {
        this.results.data[indice] = { ...this.results.data[indice], status: chamado.status };
      }
      this.edit = {};
      this.modalShow2 = false;
      this.recalcularPendenciasDaPagina();
      await this.carregarInteracoes();
    },
    async createEvent(sendData){
      let notify = {};
      if(sendData.TarefaAtribuido){
        sendData.TarefaAtribuido.map((atribuido) =>{
          if(atribuido.tipo === 'setor'){
            try{
              notify = {
                "title":`Novo chamado: #${sendData.id}`,
                "body":"Novo chamado em sua fila, clique aqui para mais detalhes!",
                "url":`/mirai/tarefa?chamado=${sendData.id}`,
                icon: "/images/cstic_only_logo.png",
                badge:"/images/favicon-32x32.png",
              }
              axios.put(`/webpush/notifysetor/${atribuido.atribuido}`,notify);
            }catch (e) {
              console.log(e)
            }
          }
        })
      }
      const cat = this.$categorias.data.findIndex(item => item.id === sendData.categoria);
      sendData.Categoria = this.$categorias.data[cat];
      sendData.all.Categoria = this.$categorias.data[cat];
      this.results.data = [sendData.all, ...this.results.data];
      this.recalcularPendenciasDaPagina();
      this.$emit('createEvent');
    },
    async updateEvent(sendData){
      let notify = {};
      if(sendData?.all?.TarefaAtribuido){
        sendData.all.TarefaAtribuido.map((atribuido) =>{
          if(atribuido.tipo === 'setor'){
            try{
              notify = {
                "title":`Chamado: #${sendData.all.id}`,
                "body":`Você acaba de receber uma mensagem referente ao chamado ${sendData.all.id}. Clique aqui para saber mais detalhes.`,
                "url":`/mirai/tarefa?chamado=${sendData.all.id}`,
                icon: "/images/cstic_only_logo.png",
                badge:"/images/favicon-32x32.png",
              }
              axios.put(`/webpush/notifysetor/${atribuido.atribuido}`,notify);
            }catch (e) {
              console.log(e)
            }
          }
        })
      }
      const indice = this.results.data.findIndex(item => item.id === sendData.all.id);
      if(indice !== -1){
        this.results.data[indice] = sendData.all;
      }
      this.edit = {};
      this.modalShow2 = false;

      const statusNormalizado = this.normalizeStatus(sendData?.all?.status);
      if (statusNormalizado === "pendente") {
        aviso({
          title: 'Chamado reaberto, nosso time entrará em contato com você em breve!',
          showConfirmButton: true,
          timer: false
        });
      } else if (statusNormalizado === "finalizada") {
        await this.abrirPesquisaSatisfacao(sendData.all, { showCancelFeedback: true });
        await this.sincronizarPendenciasPesquisa();
      } else {
        sucesso();
      }
      this.recalcularPendenciasDaPagina();
      this.$emit('createEvent');
    },
    getCategoria(categoria){
      try{
        const catt = this.$categorias.data.findIndex(cat => cat.id === categoria.id);
        return this.$categorias.data[catt]?.nome_nivelado || categoria.nome;
        //return this.$categorias.data[catt]?.nome_nivelado || categoria.nome;
      }catch (e) {
        return null;
      }
    },
    async getDatabase(data){
      this.loading = true;
      if(data && data.limit){
        this.perPage=data.limit
      }
      const filtroBase = {
        finalidade: "chamado",
        accountname: this.user,
      };
      const params = {
        limit: this.perPage,
        where: JSON.stringify(filtroBase),
      };

      if (data?.offset !== undefined && data?.offset !== null) {
        const parsedOffset = Number(data.offset);
        if (Number.isFinite(parsedOffset) && parsedOffset >= 0) {
          params.offset = parsedOffset;
        }
      }

      const queryTrim = this.query.trim();
      if(queryTrim.length > 0){
        if(this.query !== this.lastquery){
          this.lastquery = this.query;
          if (this.page !== 1) {
            this.page = 1;
            this.loading = false;
            return;
          }
        }
        params.query = queryTrim;
      }

      try{
        const result = await axios.get("/tarefa/data", { params });

        if(result.data && result.data.data){
          result.data.data = result.data.data.map(item => ({
            ...item,
            expanded: false
          }));
        }

        this.results = result.data;
      }catch (e) {
        this.results = [];
        console.error(e);
      } finally {
        this.loading = false;
        this.recalcularPendenciasDaPagina();
        await this.carregarInteracoes();
      }
    },
    async getDatabaseInput(data){
      clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        this.getDatabase(data)
      }, 700);
    },
    onSort(column) {
      this.direction = this.direction === 'asc' ? 'desc' : 'asc';
      const sortedArray = [...this.results.data];
      sortedArray.sort((a, b) => {
        const res = a[column] < b[column] ? -1 : a[column] > b[column] ? 1 : 0;
        return this.direction === 'asc' ? res : -res;
      });
      this.results.data = sortedArray;
    },
    setPages(posts) {
      const total = Number(posts?.filtered ?? posts?.count ?? 0);
      let numberOfPages = Math.ceil(total / this.perPage);
      if (!Number.isFinite(numberOfPages) || numberOfPages < 1) {
        numberOfPages = 1;
      }
      let startPage, endPage;
      if (numberOfPages <= 3) {
        // less than 3 total pages so show all
        startPage = 1;
        endPage = numberOfPages;
      } else {
        // more than 3 total pages so calculate start and end pages
        if (this.page <= 2) {
          startPage = 1;
          endPage = 3;
        } else if (this.page + 1 >= numberOfPages) {
          startPage = numberOfPages - 2;
          endPage = numberOfPages;
        } else {
          startPage = this.page - 1;
          endPage = this.page + 1;
        }
      }

      let pages = [...Array(endPage + 1 - startPage).keys()].map(i => startPage + i);
      if(pages[0] > 1) {
        // adiciona reticências no início da lista de páginas
        pages = [1, '...', ...pages];
      }
      if(pages[pages.length - 1] < numberOfPages) {
        // adiciona reticências no final da lista de páginas
        pages = [...pages, '...', numberOfPages];
      }
      this.pages = pages;
    },
  },
  watch:{
    results(newValue){
      this.setPages(newValue);
      this.recalcularPendenciasDaPagina();
    },
    page(page){
      this.getDatabase({offset:((page-1)*this.perPage)});
    }
  }
}
</script>
<style scoped>
/* Sinalização de resposta não lida.
   O destaque é deliberadamente redundante — cor da linha, ponto ao lado do
   número e etiqueta com texto — para não depender só de cor: quem tem
   dificuldade de distinguir tons continua enxergando a etiqueta. */
.chamado-linha-novidade > td {
  background-color: rgba(245, 158, 11, 0.08) !important;
}

.chamado-linha-novidade > td:first-child {
  box-shadow: inset 3px 0 0 0 #f59e0b;
}

.chamado-ponto-novidade {
  display: inline-block;
  width: 0.5rem;
  height: 0.5rem;
  margin-left: 0.35rem;
  border-radius: 999px;
  background: #f59e0b;
  vertical-align: middle;
  animation: chamado-pulso 2s ease-in-out infinite;
}

@keyframes chamado-pulso {
  0%, 100% { box-shadow: 0 0 0 0 rgba(245, 158, 11, 0.55); }
  50% { box-shadow: 0 0 0 0.28rem rgba(245, 158, 11, 0); }
}

@media (prefers-reduced-motion: reduce) {
  .chamado-ponto-novidade {
    animation: none;
  }
}

.chamado-badge-novidade {
  display: inline-flex;
  align-items: center;
  background: rgba(245, 158, 11, 0.16);
  border: 1px solid rgba(245, 158, 11, 0.3);
  color: #b45309;
  font-size: 0.72rem;
  font-weight: 700;
}

.chamado-ultima-interacao {
  display: inline-flex;
  align-items: center;
  font-size: 0.72rem;
  color: #64748b;
}

.chamado-alerta-novidade {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.6rem 0.75rem;
  border: 1px solid rgba(245, 158, 11, 0.3);
  border-radius: 0.7rem;
  background: rgba(245, 158, 11, 0.12);
  color: #92400e;
  font-size: 0.82rem;
  font-weight: 600;
}

.chamado-filtro-novidade {
  border-radius: 999px;
  font-weight: 600;
}

[data-bs-theme="dark"] .chamado-linha-novidade > td,
[data-layout-mode="dark"] .chamado-linha-novidade > td {
  background-color: rgba(245, 158, 11, 0.12) !important;
}

[data-bs-theme="dark"] .chamado-badge-novidade,
[data-layout-mode="dark"] .chamado-badge-novidade,
[data-bs-theme="dark"] .chamado-alerta-novidade,
[data-layout-mode="dark"] .chamado-alerta-novidade {
  background: rgba(245, 158, 11, 0.18);
  border-color: rgba(245, 158, 11, 0.34);
  color: #fcd34d;
}

[data-bs-theme="dark"] .chamado-ultima-interacao,
[data-layout-mode="dark"] .chamado-ultima-interacao {
  color: #9fb0c9;
}

.chamado-shell {
  --chamado-surface: linear-gradient(135deg, rgba(255, 255, 255, 0.98) 0%, rgba(245, 249, 255, 0.96) 100%);
  --chamado-card: rgba(255, 255, 255, 0.9);
  --chamado-border: #dbe5f0;
  --chamado-title: #0f172a;
  --chamado-text: #475569;
  --chamado-muted: #64748b;
  --chamado-row-alt: rgba(248, 250, 252, 0.94);
  --chamado-row-hover: rgba(219, 234, 254, 0.45);
  background: var(--chamado-surface);
  border: 1px solid var(--chamado-border);
  border-radius: 1.35rem;
  box-shadow: 0 18px 36px rgba(15, 23, 42, 0.08);
}

[data-bs-theme="dark"] .chamado-shell {
  --chamado-surface: linear-gradient(135deg, rgba(7, 12, 24, 0.98) 0%, rgba(15, 23, 42, 0.95) 54%, rgba(18, 27, 45, 0.98) 100%);
  --chamado-card: rgba(15, 23, 42, 0.8);
  --chamado-border: rgba(148, 163, 184, 0.16);
  --chamado-title: #e5eefb;
  --chamado-text: #bfd0e6;
  --chamado-muted: #9fb0c9;
  --chamado-row-alt: rgba(15, 23, 42, 0.58);
  --chamado-row-hover: rgba(37, 99, 235, 0.16);
  box-shadow: 0 24px 42px rgba(2, 8, 20, 0.28);
}

.chamado-shell-header {
  padding: 1.35rem 1.35rem 0;
  background: transparent;
}

.chamado-shell-body {
  padding: 0.85rem 1.35rem 1.35rem;
}

.chamado-shell-body .tab-content {
  color: var(--chamado-text);
}

.chamado-hero-search {
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
}

.chamado-primary-action {
  min-width: 180px;
  height: 46px;
  border-radius: 0.9rem;
  font-weight: 600;
}

.chamado-search-box {
  position: relative;
  width: min(100%, 360px);
  min-width: 0;
  padding: 0 0.2rem;
  border: 1px solid var(--chamado-border);
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.88);
  box-shadow: 0 12px 24px rgba(15, 23, 42, 0.06);
  transition: border-color 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;
}

.chamado-search-box:focus-within {
  border-color: rgba(37, 99, 235, 0.35);
  box-shadow: 0 14px 28px rgba(37, 99, 235, 0.14);
}

.chamado-search-input {
  height: 48px;
  padding-left: 2.8rem;
  padding-right: 1rem;
  border: 0;
  border-radius: 999px;
  background: transparent;
  color: var(--chamado-title);
  box-shadow: none;
}

.chamado-search-input:focus {
  background: transparent;
  color: var(--chamado-title);
  box-shadow: none;
}

.chamado-search-input::placeholder {
  color: var(--chamado-muted);
}

.chamado-search-box .search-icon {
  left: 1rem;
  color: var(--chamado-muted);
}

.chamado-table-shell {
  padding: 0.35rem 0.45rem 0.2rem;
  background: var(--chamado-card);
  border: 1px solid var(--chamado-border);
  border-radius: 1rem;
  box-shadow: 0 12px 24px rgba(15, 23, 42, 0.05);
}

.chamado-shell :deep(.table) {
  color: var(--chamado-title);
}

.chamado-shell :deep(.table > :not(caption) > * > *) {
  border-bottom-color: var(--chamado-border);
}

.chamado-shell :deep(thead.table-light),
.chamado-shell :deep(thead.table-light th) {
  background: transparent !important;
  color: var(--chamado-muted) !important;
}

.chamado-shell :deep(.table-striped > tbody > tr:nth-of-type(odd) > *) {
  background-color: var(--chamado-row-alt);
}

.chamado-shell :deep(.table-hover > tbody > tr:hover > *) {
  background-color: var(--chamado-row-hover);
}

.chamado-shell :deep(.pagination-prev),
.chamado-shell :deep(.pagination-next),
.chamado-shell :deep(.page) {
  color: var(--chamado-title);
}

[data-bs-theme="dark"] .chamado-table-shell {
  box-shadow: 0 14px 28px rgba(2, 8, 20, 0.18);
}

[data-bs-theme="dark"] .chamado-search-input {
  background: transparent;
}

[data-bs-theme="dark"] .chamado-search-box {
  background: rgba(15, 23, 42, 0.84);
  border-color: rgba(148, 163, 184, 0.2);
  box-shadow: 0 16px 28px rgba(2, 8, 20, 0.22);
}

[data-bs-theme="dark"] .chamado-search-box:focus-within {
  border-color: rgba(96, 165, 250, 0.42);
  box-shadow: 0 18px 30px rgba(37, 99, 235, 0.2);
}

[data-bs-theme="dark"] .chamado-shell :deep(.table) {
  --bs-table-bg: transparent;
}

[data-bs-theme="dark"] .chamado-shell :deep(.text-muted) {
  color: var(--chamado-muted) !important;
}

[data-bs-theme="dark"] .chamado-shell :deep(.bg-light) {
  background-color: rgba(15, 23, 42, 0.62) !important;
}

.loading-overlay-pesquisa {
  --overlay-bg: rgba(255, 255, 255, 0.7);
  --overlay-card-bg: #ffffff;
  --overlay-border: #dbe4f0;
  --overlay-color: #334155;
  position: fixed;
  inset: 0;
  z-index: 3000;
  background: var(--overlay-bg);
  backdrop-filter: blur(1px);
  display: flex;
  align-items: center;
  justify-content: center;
}

.loading-overlay-pesquisa-box {
  min-width: 180px;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  border-radius: 8px;
  background: var(--overlay-card-bg);
  border: 1px solid var(--overlay-border);
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.16);
  color: var(--overlay-color);
  font-weight: 600;
}

[data-bs-theme="dark"] .loading-overlay-pesquisa {
  --overlay-bg: rgba(7, 12, 24, 0.55);
  --overlay-card-bg: rgba(15, 23, 42, 0.96);
  --overlay-border: rgba(148, 163, 184, 0.18);
  --overlay-color: #d7e3f4;
}

@media (max-width: 768px) {
  .chamado-shell-header {
    padding: 1.1rem 1.1rem 0;
  }

  .chamado-shell-body {
    padding: 0.8rem 1.1rem 1.1rem;
  }

  .chamado-search-box {
    min-width: 100%;
  }
}
</style>
